import React from 'react';
import { Link } from 'react-router-dom';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/ui/Breadcrumb';
import type { DashboardBreadcrumb } from '@/lib/dashboardBreadcrumbs';
import { cn } from '@/lib/utils';

interface DashboardBreadcrumbsProps {
  items: DashboardBreadcrumb[];
  className?: string;
}

function BreadcrumbSegment({ item, isLast }: { item: DashboardBreadcrumb; isLast: boolean }) {
  if (isLast || !item.href) {
    return <BreadcrumbPage className="max-w-[10rem] truncate sm:max-w-none">{item.label}</BreadcrumbPage>;
  }
  return (
    <BreadcrumbLink asChild>
      <Link to={item.href} className="max-w-[8rem] truncate sm:max-w-none">
        {item.label}
      </Link>
    </BreadcrumbLink>
  );
}

function BreadcrumbTrail({ items }: { items: DashboardBreadcrumb[] }) {
  return items.map((item, index) => {
    const isLast = index === items.length - 1;
    return (
      <React.Fragment key={`${item.label}-${index}`}>
        {index > 0 ? <BreadcrumbSeparator /> : null}
        <BreadcrumbItem>
          <BreadcrumbSegment item={item} isLast={isLast} />
        </BreadcrumbItem>
      </React.Fragment>
    );
  });
}

export function DashboardBreadcrumbs({ items, className }: DashboardBreadcrumbsProps) {
  if (items.length === 0) {
    return null;
  }

  return (
    <Breadcrumb className={cn('hidden min-w-0 flex-1 sm:block', className)}>
      <BreadcrumbList className="flex-nowrap">
        <BreadcrumbTrail items={items} />
      </BreadcrumbList>
    </Breadcrumb>
  );
}
